// extracted by mini-css-extract-plugin
module.exports = {"widgetInnerPageLoader":"WidgetInnerPageLoader_widgetInnerPageLoader__2oLW0"};